<footer class="fc-footer">
  <span class="fc-address">
    Default srl Viale Europa Unita 37, 24043 Caravaggio, Italy
  </span>
  <span class="fc-iva">P.IVA 04536920160</span>
  <span class="fc-email">info@default-solutions.it </span>
  <span class="fc-copywrite">&copy; Copyright 2026 Default srl</span>
</footer>
